import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, Grid, Box } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import PdfModal from './Components/PdfModal';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function SinglePage(props) {
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page
	const [scale, setScale] = useState(0.9);
	const [zoomOutLimit, setZoomOutLimit] = useState(false);
	const [zoomInLimit, setZoomInLimit] = useState(false);
	const [PdfModalVisibility, setPdfModalVisibility] = useState(false);

	// eslint-disable-next-line no-shadow
	function onDocumentLoadSuccess({ numPages }) {
		setNumPages(numPages);
		setPageNumber(1);
	}

	function changePage(offset) {
		setPageNumber(prevPageNumber => prevPageNumber + offset);
	}

	function previousPage() {
		changePage(-1);
	}

	function nextPage() {
		changePage(1);
	}

	function _zoomOut() {
		if (scale <= 0.7) {
			setZoomOutLimit(true);
		} else {
			setScale(scale - 0.1);
			setZoomInLimit(false);
		}
	}

	function _zoomIn() {
		if (scale >= 4) {
			setZoomInLimit(true);
		} else {
			setScale(scale + 0.1);
			setZoomOutLimit(false);
		}
	}

	function _expandPdf() {
		setPdfModalVisibility(true);
	}

	function _cLoseExpandPdf() {
		setPdfModalVisibility(false);
	}

	// eslint-disable-next-line react/prop-types
	const { pdf, filename } = props;
	return (
		<>
			<div>
				<Grid container spacing={4}>
					<Grid item md={8}>
						<Button
							color="primary"
							disabled={zoomOutLimit}
							onClick={_zoomOut}
							variant="contained"
						>
							<ZoomOutIcon fontSize="small" />
						</Button>
						<Button
							color="primary"
							disabled={zoomInLimit}
							onClick={_zoomIn}
							variant="contained"
						>
							<ZoomInIcon fontSize="small" />
						</Button>
						<Button
							color="primary"
							disabled={pageNumber <= 1}
							onClick={previousPage}
							variant="contained"
							style={{ marginLeft: '10px' }}
						>
							<ArrowBackIcon fontSize="small" />
						</Button>
						<Button
							color="primary"
							disabled={pageNumber >= numPages}
							onClick={nextPage}
							variant="contained"
						>
							<ArrowForwardIcon fontSize="small" />
						</Button>
					</Grid>
					<Grid item md={4}>
						<Box display="flex" justifyContent="flex-end">
							<Button
								color="primary"
								onClick={_expandPdf}
								variant="contained"
							>
								<AspectRatioIcon fontSize="small" />
							</Button>
						</Box>
					</Grid>
					{/* <button type="button" disabled={zoomOutLimit} onClick={_zoomOut}>
				{' '}
				<ZoomOutIcon fontSize="small" />
			</button>
			<button type="button" disabled={zoomInLimit} onClick={_zoomIn}>
				{' '}
				<ZoomInIcon fontSize="small" />
			</button> */}
				</Grid>
			</div>
			<div style={{ maxWidth: '100vw', maxHeight: '100vh', overflow: 'auto', border: '1px solid lightGrey' }}>
				<Document
					file={pdf}
					options={{ workerSrc: '/pdf.worker.js' }}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					<Page pageNumber={pageNumber} scale={scale} />
				</Document>
			</div>
			<div>
				<p style={{ fontFamily: 'Roboto, Helvetica, Arial, sansSerif', fontSize: '14px', fontWeight: '400' }}>
					Page
					{' '}
					{pageNumber || (numPages ? 1 : '--')}
					{' '}
					of
					{' '}
					{numPages || '--'}
				</p>
				{/* <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
					<ArrowBackIcon fontSize="small" />
				</button>
				<button
					type="button"
					disabled={pageNumber >= numPages}
					onClick={nextPage}
				>
					<ArrowForwardIcon fontSize="small" />
				</button> */}
			</div>
			{PdfModalVisibility && (
				<PdfModal
					onClose={_cLoseExpandPdf}
					open={PdfModalVisibility}
					pdf={pdf}
					filename={filename}
				/>
			)}
		</>
	);
}
